module.exports = __webpack_public_path__ + "img/群组 4@2x.e855f401.png";